'use client';

import QRCodeLogo from '@web-catalog/public/img/qrCodeLogo.svg?url';
import QRCodeStyling from 'qr-code-styling';
import React, {useEffect, useMemo, useRef} from 'react';

import styles from './QRCode.module.scss';

type Props = {
  value: string;
  size: number;
  withLogo?: boolean;
  testId?: string;
};

// канвас рисуется в размере size * UPSCALE_BY,
// а потом даунскейлится трансформом
// это вроде бы фиксит слишком маленький куар + мыльность
const UPSCALE_BY = 2;

export const QRCode = ({value, size, withLogo = true, testId}: Props) => {
  const ref = useRef(null);

  useEffect(() => {
    const qrCode = new QRCodeStyling({
      width: size * UPSCALE_BY,
      height: size * UPSCALE_BY,
      type: 'canvas',
      data: value,
      qrOptions: {
        errorCorrectionLevel: 'L',
      },
      imageOptions: {
        margin: 8,
        imageSize: 0.8,
      },
      image: withLogo ? QRCodeLogo.src : undefined,
      dotsOptions: {
        color: '#000000',
        type: 'rounded',
      },
      backgroundOptions: {
        color: 'rgba(255,255,255,0)',
      },
      cornersSquareOptions: {
        type: 'extra-rounded',
      },
    });
    ref.current && qrCode.append(ref.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const style = useMemo(
    () =>
      ({
        width: `${size}px`,
        height: `${size}px`,
        '--scale-factor': 1 / UPSCALE_BY,
      }) as React.CSSProperties,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <div
      ref={ref}
      style={style}
      className={styles.container}
      data-testid={testId ?? 'qr'}
      data-value={value}
    />
  );
};
